import { gql } from '../../../apollo/__generated__';

export const STAFF_JOIN_BEDROOM = gql(`
  mutation StaffJoinBedroom($bedroomId: ID!, $eventId: ID!, $userId: ID!) {
    staffJoinBedroom(bedroomId: $bedroomId, eventId: $eventId, userId: $userId) {
      id
      floor
      doorNumber
      maxUsers
      users(eventId: $eventId) {
        id
        firstname
        lastname
        nickname
        studyTown
      }
    }
  }
`);
